(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    section.dataset.depictInit = '1';

    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');
    var viewport = grid.parentElement;
    var frame;
    var resizeObserver = new ResizeObserver(scheduleUpdate);

    function imageBox(card) {
      var cardRect = card.getBoundingClientRect();
      var best;
      var area = 0;
      card.querySelectorAll('.depict-recs__media, img, [data-bgset]').forEach(function (image) {
        if (image.checkVisibility ? !image.checkVisibility({ visibilityProperty: true }) : getComputedStyle(image).visibility === 'hidden') return;
        var rect = image.getBoundingClientRect();
        var top = rect.top;
        var bottom = rect.bottom;
        var left = rect.left;
        var right = rect.right;
        for (var parent = image.parentElement; parent && parent !== card; parent = parent.parentElement) {
          var style = getComputedStyle(parent);
          if (style.overflowX === 'visible' && style.overflowY === 'visible') continue;
          var clip = parent.getBoundingClientRect();
          if (style.overflowY !== 'visible') {
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
          }
          if (style.overflowX !== 'visible') {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
          }
        }
        if (bottom <= top || right <= left || top < cardRect.top - 1 || bottom > cardRect.bottom + 1) return;
        if (right <= cardRect.left || left >= cardRect.right) return;
        var visibleArea = (right - left) * (bottom - top);
        if (visibleArea > area) {
          best = { top: top, height: bottom - top };
          area = visibleArea;
        }
      });
      return best;
    }

    function updateImageCenters() {
      var gridRect = grid.getBoundingClientRect();
      var viewportRect = viewport.getBoundingClientRect();
      var left;
      var right;
      grid.querySelectorAll('[data-depict-rec-card]').forEach(function (card) {
        var rect = card.getBoundingClientRect();
        if (rect.right <= gridRect.left + 1 || rect.left >= gridRect.right - 1) return;
        var image = imageBox(card);
        if (!image) return;
        if (!left || rect.left < left.edge) left = { edge: rect.left, image: image };
        if (!right || rect.right > right.edge) right = { edge: rect.right, image: image };
      });
      [[prev, left], [next, right]].forEach(function (entry) {
        var button = entry[0];
        if (!button) return;
        if (entry[1]) {
          var image = entry[1].image;
          button.style.setProperty('--depict-recs-image-center', (image.top + image.height / 2 - viewportRect.top - viewport.clientTop) + 'px');
        } else {
          button.style.removeProperty('--depict-recs-image-center');
        }
      });
    }

    function scheduleUpdate() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        update();
      });
    }

    function observeImages() {
      resizeObserver.disconnect();
      resizeObserver.observe(grid);
      grid.querySelectorAll('[data-depict-rec-card], .depict-recs__media, img, [data-bgset]').forEach(function (element) {
        for (var parent = element; parent && parent !== grid; parent = parent.parentElement) {
          resizeObserver.observe(parent);
        }
      });
      scheduleUpdate();
    }

    // Sets data-depict-overflow when the row scrolls (drives arrow visibility)
    // and the nav-button disabled state. Skipped while display:none
    // (clientWidth 0); the ResizeObserver re-runs it once the Depict extension
    // reveals the section.
    function update() {
      if (!grid.clientWidth) return;
      updateImageCenters();
      var max = grid.scrollWidth - grid.clientWidth;
      var hasOverflow = max > 1;
      var sl = Math.abs(grid.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (hasOverflow) {
        section.setAttribute('data-depict-overflow', '');
      } else {
        section.removeAttribute('data-depict-overflow');
      }
    }

    // No behavior key: the grid's CSS scroll-behavior decides smooth vs instant,
    // so prefers-reduced-motion is honored without JS.
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9 });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });

    grid.addEventListener('scroll', scheduleUpdate, { passive: true });
    grid.addEventListener('load', scheduleUpdate, true);
    grid.addEventListener('depict:recs-updated', observeImages);
    observeImages();
    document.addEventListener('shopify:section:unload', function unload(event) {
      if (!event.target.contains(section)) return;
      resizeObserver.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    });
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scurri-embed"] && !Shopify.designMode) return;
  try {
    
    const scurriTrackPlusConfiguration = {
        companyId: '42105699-07af-4956-9602-2748d2dc651b',
        identifier: new URLSearchParams(window.location.search).get('id'),
    };
    
    (function(i,s,o,g,r,a,m){i['ScurriTrackPlusTimeline']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new
    Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.defer=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://timeline-widget.scurritrackplus.com/timeline-widget/widget.js','STPTimeline');
    
    STPTimeline('render', {
        config: scurriTrackPlusConfiguration,
        attachTo: 'scurri-embed'
    });

  } catch(e) { console.error(e); }
})();
})();
